<template>
  <pt-integral-exchange-detail class="pt-integral-exchange-detail__page" :operation="operation"></pt-integral-exchange-detail>
</template>

<script>
import PtIntegralExchangeDetail from 'cps//integral-mall-manage/pt-integral-exchange/pt-integral-exchange-detail/withData'
export default {
  name: 'pt-integral-exchange-detail__view',
  components: {
    'pt-integral-exchange-detail': PtIntegralExchangeDetail
  },
  props: {
    operation: {
      type: String,
      default: ''
    }
  }
}
</script>
